import { createTheme } from '@mui/material';

/**
 * Font family for the headers.
 */
const headersFontFamily = ['Montserrat', 'sans-serif'].join(',');
/**
 * MUI theme.
 */
const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#fff',
      dark: '#9078D3',
    },
  },
  typography: {
    fontFamily: ['Lato', 'sans-serif'].join(','),
    h1: {
      fontFamily: headersFontFamily,
    },
    h2: {
      fontFamily: headersFontFamily,
    },
    h3: {
      fontFamily: headersFontFamily,
    },
    h4: {
      fontFamily: headersFontFamily,
    },
    h5: {
      fontFamily: headersFontFamily,
    },
    h6: {
      fontFamily: headersFontFamily,
    },
  },
  components: {
    // Use `MuiDataGrid` on DataGrid, DataGridPro and DataGridPremium
    MuiDataGrid: {
      styleOverrides: {
        root: {
          backgroundColor: '#2C2071',
          border: 'none',
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          backgroundColor: '#2C2071',
          color: '#fff',
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: '#fff',
          fontSize: 18,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#fff',
          },
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: '#fff',
          fontSize: 18,
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          color: '#fff',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#2C2071',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontWeight: 'bold',
        },
      },
    },
  },
});

export { theme };
